// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetRbacMeDemoRbacMeGetQueryResponse } from "../models/demoController/GetRbacMeDemoRbacMeGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getGetRbacMeDemoRbacMeGetUrl() {
  const res = { method: 'GET', url: `/demo/rbac/me` as const }
  return res
}

/**
 * @description Get your current role and permissions for RBAC demo.
 * @summary Get Rbac Me
 * {@link /demo/rbac/me}
 */
export async function getRbacMeDemoRbacMeGet(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetRbacMeDemoRbacMeGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetRbacMeDemoRbacMeGetUrl().url.toString(), ... requestConfig })
  return res.data
}